export type HuntingUnitDisplay = {
  abbreviation: string
  value: string
}

const GENERIC_ABBREVIATION = 'Unit'

const HUNTING_UNIT_VOCABULARY: readonly {
  full: string
  abbreviation: string
  noun: string
}[] = [
  { full: 'Wildlife Management Unit', abbreviation: 'WMU', noun: 'Unit' },
  { full: 'Wildlife Management Zone', abbreviation: 'WMZ', noun: 'Zone' },
  { full: 'Game Hunting Area', abbreviation: 'GHA', noun: 'Area' },
  { full: 'Management Unit', abbreviation: 'MU', noun: 'Unit' },
]

function parseSingleUnit(label: string): HuntingUnitDisplay | null {
  for (const entry of HUNTING_UNIT_VOCABULARY) {
    const prefix = `${entry.full} `
    if (!label.startsWith(prefix)) continue
    const code = label.slice(prefix.length).trim()
    if (code === '') continue
    return { abbreviation: entry.abbreviation, value: `${entry.noun} ${code}` }
  }
  return null
}

export function huntingUnitDisplay(
  label: string | null | undefined,
): HuntingUnitDisplay | null {
  const trimmed = label?.trim()
  if (!trimmed) return null

  const abbreviations = new Set<string>()
  const values: string[] = []

  for (const part of trimmed.split(', ')) {
    const parsed = parseSingleUnit(part)
    if (!parsed) return { abbreviation: GENERIC_ABBREVIATION, value: trimmed }
    abbreviations.add(parsed.abbreviation)
    values.push(parsed.value)
  }

  if (abbreviations.size !== 1) {
    return { abbreviation: GENERIC_ABBREVIATION, value: trimmed }
  }

  return {
    abbreviation: [...abbreviations][0],
    value: values.join(', '),
  }
}
